import { ChangeDetectionStrategy, Component, ElementRef, Input } from '@angular/core';
import { ridangoIcons } from './icons';

@Component({
    selector: 'ridango-ui-icons',
    template: '<ng-content></ng-content>',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RidangoIconsComponent {
    constructor(private element: ElementRef) {}

    @Input()
    set name(iconName: string) {
        this.element.nativeElement.innerHTML = ridangoIcons[iconName] || null;
    }
}
